import { Component, OnInit, ViewChild, TemplateRef, Output, Input, OnChanges, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Subject ,  Observable } from 'rxjs';

import { IdentityTokenAmounts } from '../models/identity-token-amount-selector';
import { FormsModule } from '@angular/forms';


@Component({
    templateUrl: './identity-token-amount-selector.component.html',
    selector: 'ep-identity-token-amount-selector',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})

export class IdentityTokenAmountSelectorComponent implements OnInit, OnChanges {

    constructor() {
        const top50: IdentityTokenAmounts = {
            descriptor: '50',
            value: 50
        };
        const top100: IdentityTokenAmounts = {
            descriptor: '100',
            value: 100
        };
        const top500: IdentityTokenAmounts = {
            descriptor: '500',
            value: 500
        };
        const top1000: IdentityTokenAmounts = {
            descriptor: '1000',
            value: 1000
        };
        const top5000: IdentityTokenAmounts = {
            descriptor: '5000',
            value: 5000
        };
        const topAll: IdentityTokenAmounts = {
            descriptor: 'All',
            value: 0
        };
        this.searchAmount = [top50, top100, top500, top1000, top5000, topAll];
        this.selectedSearchAmount = this.searchAmount[0];
     }


    @Input() titleText = '';
    initializedSubject: Subject<void> = new Subject<void>();
    public initialized: Observable<void> = this.initializedSubject.asObservable();

    public searchAmount: IdentityTokenAmounts[] = [];
    @Input() public selectedSearchAmount: IdentityTokenAmounts = null;
    @Output() selectedIdentityAmountChange: EventEmitter<void> = new EventEmitter();


    public ngOnInit(): void {

    }


    ngOnChanges(changes: any) {
        if (changes.selectedDistributionObject) {
        }
    }


    public reset() {
        return this.refresh(null);
    }

    public refresh(distributionObjectId: number = null) {

        return Promise.resolve(null);
    }



    identityAmountChanged(identityAmount: IdentityTokenAmounts) {
        if (identityAmount) {
            this.selectedSearchAmount = identityAmount;
            this.selectedIdentityAmountChange.emit();
       }
       else {
        this.selectedSearchAmount = this.searchAmount[0];
        this.selectedIdentityAmountChange.emit();
       }
   }
}
